import React, { useState } from 'react';
import './Contact.css';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    organization: '',
    message: '',
  });
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);

    try {
      const response = await fetch('https://my-express-backend-production.gandhipranit.workers.dev/api/contact', { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      // if (!response.ok) {
      //   const errorText = await response.text();
      //   setError(errorText);
      //   throw new Error(errorText);
      // }

      const result = await response.text();
      setSuccess("Sent!");
      
      setFormData({
        name: '',
        email: '',
        organization: '',
        message: '',
      });
    } catch (err) {
      console.error('Error:', err);
    }
  };

  return (
    <div className="mega-container">
      <div className="contact-container">
        <h1>Let's Connect</h1>
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label htmlFor="name">Name:</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Your Name"
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder='Your Email'
              required
            />
          </div>
          <div className="form-group">
            <label htmlFor="organization">Organization:</label>
            <input
              type="text"
              id="organization"
              name="organization"
              value={formData.organization}
              placeholder="Your Organization"
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label htmlFor="message">Message:</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              placeholder="Your Story..."
              required
            ></textarea>
          </div>
          <button type="submit">Submit</button>
          {error && <p className="error-message">{error}</p>}
          {success && <p className="success-message">{success}</p>}
        </form>
      </div>
      <div className="ribbon">
        <div className="ribbon-content">
          <img src="/pranit2.jpg" alt="Profile" className="profile-pic" />
          <p className='profile-name'>Pranit Singh Gandhi</p>
          <div className='ribbon-desc'>
            <a href='https://www.linkedin.com/in/pranit-gandhi' name="linkedin-link">LinkedIn</a>
            <p id='resume-msg'>Want my résumé? Drop a message.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
